import { observer } from "mobx-react-lite";
import { FC } from "react";
import { Form } from "./Form";
import { DialogHeader } from "@/components/ui/dialog";
import { DialogDescription, DialogTitle } from "@radix-ui/react-dialog";
import { useStore } from "@/hooks/useStore";

interface AddUserProps {
	onSuccess: () => void;
}

export const AddUser: FC<AddUserProps> = observer(({ onSuccess }) => {
	const {
		uiStore: { modalStore },
	} = useStore();

	return (
		<>
			<DialogHeader>
				<DialogTitle>Add User</DialogTitle>
				<DialogDescription className="sr-only">Fill out the form to add user.</DialogDescription>
			</DialogHeader>

			<Form
				onSuccess={() => {
					modalStore.close();
					onSuccess();
				}}
			/>
		</>
	);
});
